import React from 'react'
import { Col } from 'react-bootstrap'
import ThumbnailContainer from './thumbnail-container'
import DetailsContainer from './details-container'

import './style.scss'

const Index = () => {
	return(
		<Col md={4} className="dashboard-account-left-container">
			<Col className="inner-dashboard-account-left-container">
				<ThumbnailContainer/>
				<DetailsContainer/>
			</Col>
		</Col>
	)
}

export default Index